import { HttpMethod } from '../../constants';
function replaceIDPId(idpId: string): string {
  return this.path.replace(':identityProviderId', idpId);
}
function returnPath(): string {
  return this.path;
}
export const authEndpoints = {
  [HttpMethod.Get]: {
    GetMe: {
      path: '/authentication/me',
      route: returnPath
    },
    IDPUrl: {
      path: '/authentication/identityproviders/:identityProviderId/url',
      route: replaceIDPId
    },
    // Pre-auth gate: does this subdomain's enterprise have WorkOS SSO turned on? The login
    // screen calls this to decide whether to offer the "Sign in with SSO" button. Returns
    // only { ssoEnabled } — the WorkOS org id stays server-side.
    WorkOsSsoInitiate: {
      path: '/authentication/sso/initiate',
      route: returnPath
    },
    // Org-scoped WorkOS SSO login. A fully server-side redirect: the browser navigates
    // full-page here (with ?subdomain=&returnTo=), the dashboard resolves the enterprise's
    // WorkOS org, redirects to WorkOS, handles the callback + code exchange, sets the session
    // cookie, and 302s back to `returnTo`. The auth code never reaches browser JS.
    WorkOsSsoLogin: {
      path: '/authentication/sso/login',
      route: returnPath
    }
  },
  [HttpMethod.Post]: {
    Authentication: {
      path: '/authentication',
      route: returnPath
    },
    Logout: {
      path: '/authentication/logout',
      route: returnPath
    },
    ForgotPassword: {
      path: '/authentication/forgot-password',
      route: returnPath
    },
    ResetPassword: {
      path: '/authentication/reset-password',
      route: returnPath
    },
    IDPAuth: {
      path: '/authentication/identityproviders/:identityProviderId',
      route: replaceIDPId
    },
    IdentificationProtocols: {
      path: '/authentication/protocols',
      route: returnPath
    },
    OTP: {
      path: '/authentication/otp',
      route: returnPath
    },
    OTPValidation: {
      path: '/authentication/otp/validate',
      route: returnPath
    },
    ResendOTP: {
      path: '/authentication/otp/resend',
      route: returnPath
    }
  },
  [HttpMethod.Put]: {
    RefreshToken: {
      path: '/authentication/token/refresh',
      route: returnPath
    }
  }
};
export default authEndpoints;